import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import HighResOrdersContainer from "../OrderListContainer";
import RapidEMBookingsContainer from "../RapidEMBookingContainer";
import "./index.scss";

const ListContainer = () => {
  const location = useLocation();
  const { tab } = location?.state ?? {};
  const active = tab || "orders";
  const [activeTab, setActiveTab] = useState(active);
  return (
    <div>
      <div className="submenu">
        <div className="submenu-wrapper">
          <span
            className={`menu ${activeTab === "orders" ? "active" : ""}`}
            onClick={() => setActiveTab("orders")}
            aria-hidden
          >
            High Resolution Imagery Orders
          </span>
          <span
            className={`menu ${activeTab === "em-booking" ? "active" : ""}`}
            onClick={() => setActiveTab("em-booking")}
            aria-hidden
          >
            Rapid-EM™ Bookings
          </span>
        </div>
      </div>

      {/* containers */}
      {activeTab === "orders" ? (
        <HighResOrdersContainer />
      ) : (
        <RapidEMBookingsContainer />
      )}
    </div>
  );
};

export default ListContainer;
